import {handleActions} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';

const imageReducer = handleActions(
    {
        [actionTypes.LIKE_IMAGE_SUCCESS]: (state, action) => {
            return {
                ...state,
                liked: true,
                likes: [...state.likes, action.payload.newLike],
            };
        },
        [actionTypes.UNLIKE_IMAGE_SUCCESS]: (state, action) => {
            return {
                ...state,
                liked: false,
                likes: state.likes.filter(l => l.loginId !== action.payload.loginId),
            };
        },
        [actionTypes.TAG_IMAGE_SUCCESS]: (state, action) => {
            return {
                ...state,
                tags: [...state.tags, action.payload.newTag],
            };
        },
        [actionTypes.REMOVE_IMAGE_TAG_SUCCESS]: (state, action) => {
            return {
                ...state,
                tags: state.tags.filter(t => t.childId !== action.payload.childId),
            };
        },
    },
    {},
);

const imageAction = (state, action) => {
    const index = state.findIndex(image => image.imageId === action.payload.imageId);
    if (index === -1) {
        return state;
    }

    return [...state.slice(0, index), imageReducer(state[index], action), ...state.slice(index + 1)];
};

const imagesReducer = handleActions(
    {
        [actionTypes.LIKE_IMAGE_SUCCESS]: imageAction,
        [actionTypes.UNLIKE_IMAGE_SUCCESS]: imageAction,
        [actionTypes.TAG_IMAGE_SUCCESS]: imageAction,
        [actionTypes.REMOVE_IMAGE_TAG_SUCCESS]: imageAction,
    },
    [],
);

export default imagesReducer;
